import * as React from "react";
import "./SettingsButton.scss";
import { IconButton } from "@mui/material";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";

interface SettingsButtonProps {
  expanded: boolean;
  setExpanded: (expanded: boolean) => void;
}

const SettingsButton: React.FC<SettingsButtonProps> = ({ expanded, setExpanded }) => {
  return (
    <div className="SettingsButton">
      <IconButton onClick={() => setExpanded(!expanded)} size="large">
        <MenuOutlinedIcon />
      </IconButton>
    </div>
  );
};

export default SettingsButton;
